export const actionTypes = {
    fetchBatches: 'FETCH_BATCHES',
    receiveBatches: 'RECEIVE_BATCHES',
    clearBatches : 'CLEAR_BATCHES'
};

export const clearBatches = { type: actionTypes.clearBatches };

